'use strict'
angular.module('manuscriptAttributeConfigCreatedAttributeModule', [])
    .controller('manuscriptAttributeConfigCreatedAttributeCtrl', ['$scope', '$modalInstance', 'trsspliceString', 'trsHttpService', 'modalDialog', '$q', 'attrBaseData', '$validation', function($scope, $modalInstance, trsspliceString, trsHttpService, modalDialog, $q, attrBaseData, $validation) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                title: attrBaseData.isNew ? '新建广电文稿属性配置' : '修改广电文稿属性配置',
                isNew: attrBaseData.isNew,
                items: [{
                    name: '文本框',
                    value: 'input'
                }, {
                    name: '下拉框',
                    value: 'select'
                }],
                selectedItem: 'input'
            };

            $scope.data = {
                ATTRDESC: '',
                ATTRNAME: '',
                KEYWORDS: [],
                options: '',
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            if (!$scope.status.isNew) {
                getAttrDataById();
            }
        }

        /**
         * [getAttrDataById 获取属性数据]
         * @return {[type]} [description]
         */
        function getAttrDataById() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_docexattribute',
                methodname: 'findDocAttrById',
                ObjectId: attrBaseData.data.DOCEXATTRIBUTEID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.selectedItem = data.FORMTYPE;
                $scope.data.ATTRDESC = data.ATTRDESC;
                $scope.data.ATTRNAME = data.ATTRNAME;
                if (data.FORMTYPE == 'select') {
                    $scope.data.options = data.ENUMVALUE;
                    initSelectOptions();
                }
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initSelectOptions 初始化下拉选项数据]
         * @return {[type]} [description]
         */
        function initSelectOptions() {
            var array = [];
            $scope.data.options = $scope.data.options.split(',');
            for (var i = 0; i < $scope.data.options.length; i++) {
                var obj = $scope.data.options[i];
                array.push({
                    name: obj
                });
            }
            $scope.data.KEYWORDS = array;
        }

        $scope.leave = function() {
            $scope.isShowKeywordTips = false;
        };

        $scope.enter = function() {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.data.KEYWORDS) && (!reg.test($scope.data.KEYWORDS) || $scope.data.KEYWORDS.length > 20)) {
                $scope.isShowKeywordTips = true;
            }
            /*if (angular.isDefined($scope.keywordsTips) && $scope.keywordsTips !== "") {
                $scope.isShowKeywordTips = true;
            }*/
        };

        //检验关键词的总个数和总记录长度
        $scope.invalidTag = function(tag) {
            var reg = /^[^<>\/]*$/;
            if (tag.name.length > 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = "单个选项文字长度不能超过10";
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = "不能包含特殊字符";
            }
        };

        $scope.checkTag = function(tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 15) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = "选项个数不能超过15个";
                return false;
            } else {
                $scope.keywordsTips = "";
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(" ") > -1) {
                var spaceArr = tag.name.split(" ");
                $timeout(function() {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ 'name': spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };

        /**
         * [setSelect 选中类型]
         * @param {[type]} type [description]
         */
        $scope.setSelect = function(type) {
            if (type.value == $scope.status.selectedItem) return;
            $scope.status.selectedItem = type.value;
        };

        /**
         * [close 关闭]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm 保存]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var defer = $q.defer();
            $validation.validate($scope.createdAttributeForm).success(function() {
                if ($scope.status.selectedItem == 'select' && $scope.data.KEYWORDS.length == 0) {
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = "请输入下拉框选项";
                    modalDialog.alertType('提交失败', '请检查表单', 'info', false, function() {});
                    return;
                }
                var params = {
                    serviceid: 'mlf_docexattribute',
                    methodname: 'saveDocAttr',
                    ObjectId: $scope.status.isNew ? '0' : attrBaseData.data.DOCEXATTRIBUTEID,
                    attrName: $scope.data.ATTRNAME,
                    attrDesc: $scope.data.ATTRDESC,
                    formType: $scope.status.selectedItem,
                    attrlength: '',
                    enumValue: trsspliceString.spliceString($scope.data.KEYWORDS, 'name', ','),
                };
                if ($scope.status.selectedItem == 'input') {
                    params.attrlength = 50; //前端写死长度为50字符
                    params.enumValue = '';
                } else {
                    delete params.attrlength;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('提交成功', '', 'success', false, function() {
                        defer.resolve();
                        $modalInstance.close('success');
                    });
                });
                return defer.promise;
            }).error(function() {
                if ($scope.status.selectedItem == 'select' && $scope.data.KEYWORDS.length == 0) {
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = "请输入下拉框选项";
                }
                modalDialog.alertType('提交失败', '请检查表单', 'info', false, function() {});
            });
        };
    }]);